import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allOrders } from 'app/mocks/data/operations/orders'

import { api } from 'app/utils/constants'

import { CancelOrderPayload } from 'app/types/operations/order'

export const cancelOrder = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.CANCEL}`,
    async ({ request, params }) => {
        const { id } = params

        const payload = await request.json()
        const payloadParsed = CancelOrderPayload.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const orderFound = allOrders.find((order) => order.id.toString() === id)

        // Not found
        if (!orderFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
